<template>
  <div class="content bg-white">
    <div class="top">
      <div class="tf">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>公告列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ts">
        <p style="padding-left:38%;">公告内容</p>
        <p style="padding-right:10%;">时间</p>
      </div>
    </div>
    <div class="boxContent">
      <div class="center" v-for="(item,index) in ggMList" :key="index">
        <div class="gg_content">
          <p class="title">{{ item.title }}</p>
          <p class="lh24">{{ item.content }}</p>
        </div>
        <span class="gg_time">{{ item.create_time }}</span>
      </div>
    </div>
    <div class="bottom">
      <el-pagination
          background
          v-if="totalNotice>pageSize"
          @current-change="handleCurrentChange"
          :current-page="pageNo"
          :page-size="pageSize"
          layout=" prev, pager, next"
          :total="totalNotice">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ggMList: [],//公告的列表
      pageNo: 1,
      pageSize: 10,
      totalNotice: 0,
    }
  },
  created() {
    this.getGDGG()
  }
  , methods: {
    handleCurrentChange(val) {
      this.pageNo = val
      this.getGDGG()
    },
    async getGDGG() {
      const res8 = await this.$http.get('index.php/user/internal/notice_list', {
        page: this.pageNo,
        pageSize: this.pageSize
      })// 获取更多公告的列表
      this.ggMList = res8.data.data
      this.totalNotice = res8.data.total
    },
  }
}
</script>

<style scoped>
.ts p{
  font-size: 16px;
}
.title{
  font-size: 16px;
  color: #333;
  font-weight: bold;
}
.content {
  align-items: center;
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  margin-top: 15px;
  margin-bottom: 20px;
}

.tf {
  padding: 30px 0px 20px 25px;
  width: 100%;
}

.ts {
  display: flex;
  justify-content: space-between;
  margin: 0px 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e7e7e7;
}

.center {
  display: flex;
  justify-content: space-between;
  margin: 0px 25px;
  border-bottom: 1px dashed #e7e7e7;
}

.gg_content {
  text-align: left;
  padding: 10px 0px;
  width: 80%;
}

.gg_content p {
  margin-bottom: 10px;
}

.gg_time {
  padding: 10px;
  padding-top: 30px;
}

.boxContent {
  min-height: 68vh;
}

.bottom {
  height: 50px;
  width: 100%;
}

.bottom >>> .el-pagination {
  text-align: center;
  padding-top: 5px;
}
</style>